import { useState } from "react"
import { FaFilePdf } from "react-icons/fa"
import studentServices from "../../../services/student.services"
const StudentDocView = (props) => {
    const DownLoadDoc = (obj) => {

        studentServices.getStudentDoc(obj).then(resp => {
            window.open(resp.data.data.signedUrl);
        })
    }
    return (
        <div className="prior_crtfcts">
            <ul>
                {
                    props && props?.MapData ? props.MapData.map(curr => {
                        return (

                            <li>
                                <div onClick={() => { }} className="file_div d-flex align-items-center">
                                    <div className="fl_icn">
                                        <FaFilePdf />
                                    </div>
                                    <div className="fl_txt">

                                        <p onClick={() => {
                                            DownLoadDoc({
                                                doc_type: props.type,
                                                document: curr.file
                                            })
                                        }}>
                                            {curr.file}
                                        </p>
                                    </div>
                                </div>
                            </li>

                        )
                    }) : "N/A"
                }
            </ul>
        </div>
    )
}
export default StudentDocView